import hydrate from '../common/hydrate';
import CommonUspTeaser from './components/CommonUspTeaser';
import { root, name } from './manifest.json';
hydrate(CommonUspTeaser, root, name);
if (module.hot) {
    module.hot.accept();
}
